function CancelMainPage({ setSelectedReason, selectedReason, setOtherReason, button }) {

    const reasons = [
        "Programs are too hard",
        "Using app is too difficult",
        "Membership is too expensive",
        "I'm not using the programs",
        "Injury",
        "Others",
    ]

    return (
        <div id="cancel-main">
            <div className="cmp-header">
                <p>Sorry to see you  go!</p>

                <div className="cmp-subheader">
                    <p>We are continually improving and finding new ways to help you move, exercise and stay healthy.</p>
                </div>
            </div>

            <div id="cmp-content">
                <h5>Why are you leaving?</h5>

                <div id="cancel-reasons">
                    <div id="cancel-reasons-wrapper">
                        {
                            reasons.map((reason, i) => {
                                return (
                                    <div key={"cr-" + i} onClick={() => {
                                        setSelectedReason(reason);
                                    }}>
                                        <div className="g-border-indigo">
                                            <div className={`${selectedReason == reason ? "g-indigo" : ""}`}>
                                                <h5>{reason}</h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    {
                        selectedReason == "Others"
                            ? <textarea className="form-control" placeholder="Type here..."
                                onChange={(e) => {
                                    setOtherReason(e.target.value)
                                }}
                            />
                            : ""
                    }

                    <div className="cmp-btn-div cancel-v2-button">
                        {
                            button
                        }
                    </div>
                </div>

            </div>
        </div>
    );
}

export default CancelMainPage;